// extracted by mini-css-extract-plugin
export default {"mainContent":"MainPage_mainContent__2UL4l"};